import type { VariantProps } from "class-variance-authority";
import React from "react";

import { textVariants } from "./Text";

type Component = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "label";

export type TextGroupProps = VariantProps<typeof textVariants> & {
  readonly component?: Component;
  readonly id?: string;
  readonly htmlFor?: string;
  readonly children: React.ReactNode;
};

/**
 * @deprecated Use semantic HTML elements with `type-*` utility classes instead.
 * Example: `<h2 className="type-heading-lg text-foreground">`
 */
export default function TextGroup({
  component = "span",
  id,
  htmlFor,
  children,
  variant,
  tone,
  weight,
  align,
  truncate,
  display,
}: TextGroupProps): React.ReactElement {
  return React.createElement(
    component,
    {
      className: textVariants({
        variant,
        tone,
        weight,
        align,
        truncate,
        display,
      }),
      id,
      htmlFor,
    },
    children,
  );
}
